import { memo } from 'react';

import { useNativePushListeners } from '@/features/notifications/hooks/useNativePushListeners';

export const NativePushNotificationHandler = memo(
  function NativePushNotificationHandler() {
    useNativePushListeners();
    return null;
  },
);
